import { useQuery } from '@tanstack/react-query';
// api
import { dashboardApi } from '@/domains/traffic-monitoring/apis/dashboard';
// constant
import { DASHBOARD_CONSTANTS } from '@/domains/traffic-monitoring/constants/dashboard.constants';
import type { TrafficCongestionParams } from '../types/dashboard.types';

const pad = (n: number) => String(n).padStart(2, '0');

// "16:00 - 17:00" from the peak hour-of-day; "-" when there's no data.
const formatPeakHour = (hour: number | null | undefined): string => {
  if (hour === null || hour === undefined) return '-';
  return `${pad(hour)}:00 - ${pad((hour + 1) % 24)}:00`;
};

// PSC_PC0203001_BE_003 - overall congestion % for the day + the peak hour.
export const useTrafficCongestion = (params: TrafficCongestionParams = {}) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['trafficCongestion', params],
    queryFn: () => dashboardApi.getTrafficCongestion(params),
    staleTime: DASHBOARD_CONSTANTS.CROSSROAD_DASHBOARD.STALE_TIME_MS,
    gcTime: DASHBOARD_CONSTANTS.CROSSROAD_DASHBOARD.CACHE_TIME_MS,
    refetchInterval: DASHBOARD_CONSTANTS.CROSSROAD_DASHBOARD.REFETCH_INTERVAL_MS,
    placeholderData: (prev) => prev,
  });

  const d = data?.data;
  return {
    congestionPct: d?.total_congestion_pct ?? 0,
    peakHour: formatPeakHour(d?.peak_congestion_hour?.hour),
    // Vehicles detected in that same peak hour, not today's running total.
    peakVolume: d?.peak_congestion_hour?.volume ?? 0,
    avgSpeedKph: d?.avg_speed_kph ?? null,
    sampleCount: d?.sample_count ?? 0,
    isLoading,
    isError,
  };
};
